import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import autobind from 'react-autobind'
import { Link, Redirect,
  withRouter } from 'react-router-dom';
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import QRCode from 'react-qr-code';
import PropTypes from 'prop-types';
import * as actions from '../../redux/actions'
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import Subheader from "../../components/Subheader";
import FilterSorter from "../../components/FilterSorter";
import StoryListItem from "../../components/Story/StoryListItem";
import Dialog from "../../components/Dialog/Dialog";
import Pagination, { ITEMS_PER_PAGE } from "../../components/Pagination/Pagination"
import StatisticsTiles from "../../components/Statistics/StatisticsTiles";

import { qrCodeProxyURLStory } from "../../lib/data"

const sortFuncGen = (property, direction) => {
  const up = direction === "asc" ? 1 : -1;
  const down = direction === "asc" ? -1 : 1
  return ((a, b) => (a[property] < b[property] || !a[property] ? down : up))
}

class Stories extends PureComponent {

  constructor(props) {
    super(props)
    autobind(this)

    this.state = {
      toDeleteProductId: null,
      disabled: false,
      confirmDeleteModalOpen: false,
      priceSet: false,
      filterOrSortChanged: false,
      dropDownOpenCollection: false,
      dropDownOpenShow: false,
      dropDownOpenSortBy: false,
    }

    this.filterByCollection = [
      {
        name: "All", filterFunc: i => true, onSelect: this.categFilterBy
      }
    ]
    this.sortbyItems = [
      {
        name: "Publish Date (desc)", sortFunc: sortFuncGen("publishedAt", "desc"), onSelect: this.sortby
      },
      {
        name: "Publish Date (asc)", sortFunc: sortFuncGen("publishedAt", "asc"), onSelect: this.sortby
      },
      {
        name: "Created Date (asc)", sortFunc: sortFuncGen("createdAt", "asc"), onSelect: this.sortby
      },
      {
        name: "Created Date (desc)", sortFunc: sortFuncGen("createdAt", "desc"), onSelect: this.sortby
      }
    ]

    this.filterByItems = [
      {
        name: "Available:", filterFunc: i => new Date(i.endDate) > new Date(), onSelect: this.filterby
      },
      {
        name: "- Published", filterFunc: i => i.published && new Date(i.endDate) > new Date() && i.adminApproved, onSelect: this.filterby
      },
      {
        name: "- Unpublished", filterFunc: i => !i.published && new Date(i.endDate) > new Date() && i.adminApproved, onSelect: this.filterby
      },
      {
        name: "- Pending approval", filterFunc: i => !i.adminApproved && new Date(i.endDate) > new Date(), onSelect: this.filterby
      },
      {
        name: "Archived", filterFunc: i => new Date(i.endDate) < new Date(), onSelect: this.filterby
      }
    ]
  }

  componentDidMount() {
    const { stories, getStories, getUserStatistics } = this.props;

    if (stories.length === 0) {
      getStories().catch((error) => {
        console.error("Loading stories failed", error);
      });
    }

    getUserStatistics().catch((error) => {
      console.error("Loading statistics failed", error);
    });
  }

  filterStories(stories) {
    const { filterByCollectionIndex, filterByIndex, sortByIndex, query } = this.props;

    const categs = stories.reduce((p, c) => {
      if (p.findIndex(x => x._id === c.category._id) === -1) { p.push(c.category) }
      return p
    }, []).sort((a, b) => a.sortIndex - b.sortIndex)


    this.filterByCollection = [
      this.filterByCollection[0],
      ...categs.map(c => ({
        name: c.name, filterFunc: p => p.category._id === c._id, onSelect: this.categFilterBy
      }))
    ]

    return this._filterStories(stories, query, filterByIndex, filterByCollectionIndex, sortByIndex);
  }

  editStory(storyId) {
    const { history } = this.props;
    history.push(`/stories/update/${storyId}`)
  }

  _filterStories(stories, searchKeywords, filterByIndex, filterByCollectionIndex, sortByIndex) {

    const searchFilterFunc = searchKeywords < 3 ? p => true : p => new RegExp(searchKeywords, 'gi').test(p.name)

    return stories.slice(0)
      .sort(this.sortbyItems[sortByIndex].sortFunc)
      .filter(searchFilterFunc)
      .filter(this.filterByCollection[filterByCollectionIndex].filterFunc)
      .filter(this.filterByItems[filterByIndex].filterFunc)
  }

  onSearch(searchKeywords) {
    const { storiesPaginateDataChanged } = this.props

    storiesPaginateDataChanged({
      query: searchKeywords
    });
    this.setState((prevState) => { !prevState.filterOrSortChanged });
  }

  sortby(sortByIndex) {
    const { storiesPaginateDataChanged } = this.props;

    storiesPaginateDataChanged({
      sortByIndex
    });
    this.setState((prevState) => {
      !prevState.filterOrSortChanged
    });
  }

  filterby(filterByIndex) {
    const { storiesPaginateDataChanged } = this.props;

    storiesPaginateDataChanged({
      filterByIndex
    });
    this.setState((prevState) => {
      !prevState.filterOrSortChanged
    });
  }

  categFilterBy(filterByCollectionIndex) {
    const { storiesPaginateDataChanged } = this.props;

    storiesPaginateDataChanged({
      filterByCollectionIndex
    });
    this.setState((prevState) => { !prevState.filterOrSortChanged });
  }

  toggle(target) {
    const field = `dropDownOpen${target}`;
    this.setState(prevState => ({
      [field]: !prevState[field]
    }))

  }

  publishStory(storyId) {
    const { updateStory } = this.props;
    const dataToUpload = {
      published: true
    }

    updateStory(dataToUpload, storyId);
  }

  unPublishStory(storyId) {
    const { updateStory } = this.props;
    const dataToUpload = {
      published: false
    }

    updateStory(dataToUpload, storyId);
  }

  confirmDeleteModalProceed() {
    const { toDeleteStoryId } = this.state;
    const { deleteStory } = this.props;
    if (toDeleteStoryId) {
      deleteStory(toDeleteStoryId, () => { this.confirmDeleteModalHide() });
    }
  }

  confirmDeleteModalShow(storyId) {
    this.setState({
      toDeleteStoryId: storyId,
      confirmDeleteModalOpen: true
    })
  }

  confirmDeleteModalHide() {
    this.setState({
      confirmDeleteModalOpen: false
    })
  }

  updatePage(e, page) {
    e.preventDefault()
    const { storiesPaginateDataChanged } = this.props;
    storiesPaginateDataChanged({
      currentPage: page
    });

    this.setState((prevState) => {
      !prevState.filterOrSortChanged
    })
  }

  paginateStories(stories) {
    const { currentPage } = this.props;
    const from = currentPage * ITEMS_PER_PAGE;
    const to = from + ITEMS_PER_PAGE

    return stories.slice(from, to)
  }

  createFilterOptions = () => {
    const { filterByCollectionIndex, filterByIndex, sortByIndex } = this.props;
    return [{
      type: "dropdown",
      name: "collection",
      title: "Collection",
      selectedIndex: filterByCollectionIndex,
      items: this.filterByCollection,
      isOpen: this.state.dropDownOpenCollection,
      toggle: () => this.toggle('Collection')
    },
    {
      type: "dropdown",
      name: "show",
      title: "Show",
      selectedIndex: filterByIndex,
      items: this.filterByItems,
      isOpen: this.state.dropDownOpenShow,
      toggle: () => this.toggle('Show')
    },
    {
      type: "dropdown",
      name: "sortby",
      title: "Sort by",
      selectedIndex: sortByIndex,
      items: this.sortbyItems,
      isOpen: this.state.dropDownOpenSortBy,
      toggle: () => this.toggle('SortBy')
    }
    ]
  }

  render() {
    const { user, stories, statistics, impersonating, currentPage, storiesPaginateDataChanged, query } = this.props
    const { confirmDeleteModalOpen } = this.state

    if (!user) {
      return <Redirect to="/login" />
    }

    if (user.role === 3) {
      return <Redirect to="/s/dashboard" />
    }

    let storiesList = [];

    if (stories) {
      const filteredStories = this.filterStories(stories);
      storiesList = filteredStories.map((story, index) => (
        <StoryListItem
          index={index + 1}
          key={story._id}
          impersonating={impersonating}
          storyId={story._id}
          imagePath={story.storyPath}
          title={story.name}
          category={story.category.name}
          views={story.views}
          referenceId={story.referenceId}
          endDate={story.endDate}
          publishedAt={story.publishedAt}
          published={story.published}
          disabled={story.disabled}
          adminApproved={story.adminApproved}
          isPriceSet={story.priceSet}
          publishStory={this.publishStory}
          unPublishStory={this.unPublishStory}
          editStory={this.editStory}
          deleteStory={this.confirmDeleteModalShow}
          user={user}
          storyAccessLink={story.storyAccessLink}
          />
      ));

      storiesPaginateDataChanged({
        fileteredStoriesCount: filteredStories.length
      });
    }


    const paginatedStories = this.paginateStories(storiesList);
    return (
      <div>
        <Header />
        <Subheader
          search
          breadcrumbs={[{
            title: "Storyboard", link: "/stories"
          }]}
          onSearch={this.onSearch}
          searchValue={query}
        />
        <div className="stastistics-subheader">
          <div className="container mb-5">
            <StatisticsTiles statistics={statistics} />
          </div>
        </div>
        <div className="container mt-5 stories">
          <div className="row product-general-wrapper no-gutter">
            <div className="col-10 items-list-filters align-items-center justify-content-between">
              <h4 className="mb-0 pl-4">
                Your Stories List (
                {storiesList.length}
                )
              </h4>
              <FilterSorter options={this.createFilterOptions()} />
            </div>
            <div className="col-2 align-items-right no-gutters">
              <Link to="/stories/new">
                <button
                  type="button"
                  className="btn btn-lg btn-primary btn-fill"
                  onClick={this.createStory}
                >
                  <i className="icon icon-left s7-plus" />
                  Request new story
                </button>
              </Link>
            </div>
          </div>
          <div className="items-list items-list--products mt-5">
            <div className="items-labels">
              <div className="items-label-1">Story details</div>
              <div className="items-label-2">Status</div>
              <div className="items-label-3">Available until</div>
              <div className="items-label-4">Collection</div>
              <div className="items-label-5">Actions</div>
              <div className="items-label-6">Manage</div>
            </div>
            {storiesList.length ? paginatedStories : <p className="text-center">No stories found.</p>}
          </div>
          <Pagination currentPage={currentPage} itemsCount={storiesList.length} onClick={(e, page) => { this.updatePage(e, page) }} />

          <Dialog open={confirmDeleteModalOpen} proceed={this.confirmDeleteModalProceed} cancel={this.confirmDeleteModalHide} message="If you delete this story you won't be able to retrieve the data." />
        </div>
        <Footer />
      </div>
    )
  }
}

Stories.propTypes = {
  getStories: PropTypes.func.isRequired,
  getUserStatistics: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  updateStory: PropTypes.func.isRequired,
  currentPage: PropTypes.number,
  user: PropTypes.object.isRequired,
  stories: PropTypes.array.isRequired,
  statistics: PropTypes.array,
  impersonating: PropTypes.bool.isRequired,
  deleteStory: PropTypes.func.isRequired,
  storiesPaginateDataChanged: PropTypes.func.isRequired,
  filterByCollectionIndex: PropTypes.number.isRequired,
  filterByIndex: PropTypes.number.isRequired,
  sortByIndex: PropTypes.number.isRequired,
  query: PropTypes.string.isRequired,
}

Stories.defaultProps = {
  currentPage: 0,
  statistics: []
}

export default connect(
  (state, ownProps) => {
    const {
      auth: { user, impersonating },
      stories: { allStories, storiesPaginateData },
      statistics: { statistics }
    } = state
    const { filterByCollectionIndex, filterByIndex, sortByIndex, currentPage, query } = storiesPaginateData;

    return {
      ...ownProps,
      stories: allStories,
      user,
      impersonating,
      statistics,
      filterByCollectionIndex,
      filterByIndex,
      sortByIndex,
      currentPage,
      query
    }
  },
  actions,
  (stateProps, dispatchProps) => Object.assign({}, stateProps, dispatchProps)
)(withRouter(Stories))



// WEBPACK FOOTER //
// ./src/containers/Stories/Stories.js